module.exports = __webpack_public_path__ + "img/txtc_btn_lijitixian.2eabe192.png";